import { proxy, useSnapshot } from "valtio"
import { useMemo } from "react"

export function usePaginator({ initialLimit = 10, initialOffset = 0, sizeOfCurrentPage = 10 } = {}) {
    const store = useMemo(
        () =>
            proxy({
                limit: initialLimit,
                offset: initialOffset,
                sizeOfCurrentPage,
            }),
        []
    )

    const state = useSnapshot(store);

    const events = {
        triggerNext: () => {
            store.offset += store.limit
        },
        triggerPrev: () => {
            store.offset = Math.max(0, store.offset - store.limit)
        },
        setLimit: (newLimit: number) => {
            store.limit = newLimit
            store.offset = 0
        },
        setOffset: (newOffset: number) => {
            store.offset = newOffset
        },
        setSizeOfCurrentPage: (newSize: number) => {
            store.sizeOfCurrentPage = newSize
        },
    }

    return { state, events }
}
